export default {
  name: 'workhistory',
  data () {
    return {
      label: 'WORK HISTORY',
      componentValue: this.value
    }
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  watch: {
    componentValue: function () {
      this.$emit('input', this.componentValue)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/workhistory/script.js